document.addEventListener('DOMContentLoaded', function () {
  const mascot = document.getElementById('jco-mascot');
  const mascotButton = document.getElementById('jco-mascot-button');
  const image = document.getElementById('jco-mascot-image');
  const bubble = document.getElementById('jco-mascot-bubble');
  const message = document.getElementById('jco-mascot-message');
  const closeButton = document.getElementById('jco-mascot-close');

  if (!mascot || !mascotButton || !bubble || !message) return;

  let bubbleTimer;
  let lastMessage = '';
  let scrollMessageShown = false;
  let interactionCount = 0;

  /* =====================================================
     STORIE'S PERSONALITY
  ===================================================== */

  const messages = {

    home: [
      'Hi, I’m Storie ☁️ Welcome to J & Co. Collective!',
      'Little things, made especially for your people 💛',
      'Have a look around — there’s a little bit of magic everywhere ✨',
      'Need help finding the perfect personalised gift? I’m right here ☁️'
    ],

    product: [
      'This one is cuteee 👀✨',
      'Need help choosing your colours? I can help! 🎨',
      'Remember — this one is made especially for you 💛',
      'Not sure what to personalise it with? Ask me ☁️'
    ],

    visor: [
      'A little piece of your favourite people for every drive 💛',
      'Need help choosing the name or colour for this one? ☁️',
      'These make such special little gifts 🥹'
    ],

    toothfairy: [
      'A little tooth fairy magic ✨🦷',
      'Imagine their face waking up to this 🥹',
      'Need help choosing the perfect fairy colours? ☁️'
    ],

    photo: [
      'Your favourite little memories deserve somewhere special 💛',
      'This would be SO cute with your favourite photo 🥹',
      'Need help personalising this one? Just tap me ☁️'
    ],

    keychain: [
      'Tiny, personalised and made just for you ✨',
      'Which colour combo are we choosing? 🎨',
      'These are such sweet little gifts 💛'
    ],

    school: [
      'Making the little milestones extra special ✨',
      'First days are a big deal 🥹💛',
      'Need help with a name, colour or wording?'
    ],

    dog: [
      'Okay but personalised pet things are ALWAYS cute 🐾',
      'This one needs their name on it 😍',
      'Need help picking a colour for your furry little person?'
    ],

    cake: [
      'This is going to look SO cute on the cake 🎂✨',
      'Tell me the name and theme — I’ll help with the rest ☁️'
    ],

    wholesale: [
      'Stocking J & Co.? I LOVE that for us ☁️✨',
      'Need help with wholesale quantities or customisation? Send me a message!',
      'Want to know what’s popular with other customers? Ask me 💛'
    ],

    cart: [
      'Your goodies are almost yours! 🥹',
      'One last little check before checkout 💛',
      'Need help with anything before you order? Tap me ☁️',
      'Pssst… Afterpay is available too ✨'
    ],

    afterpay: [
      'Yep — you can use Afterpay here 💚',
      'Want it now and split the payments? Afterpay is available ✨'
    ],

    default: [
      'Hi! I’m Storie ☁️',
      'Need a hand with anything?',
      'Made with a little bit of magic ✨',
      'I’m always here if you need help 💛'
    ]
  };


  /* =====================================================
     PAGE + PRODUCT DETECTION
  ===================================================== */

  function textOnPage() {
    return document.body.innerText.toLowerCase();
  }

  function getContext() {
    const path = window.location.pathname.toLowerCase();
    const text = textOnPage();

    if (path === '/' || path === '') return 'home';
    if (path.includes('/cart')) return 'cart';

    if (
      path.includes('wholesale') ||
      text.includes('wholesale')
    ) return 'wholesale';

    if (path.includes('/products/')) {
      if (text.includes('visor')) return 'visor';

      if (
        text.includes('tooth fairy') ||
        text.includes('tooth-fairy')
      ) return 'toothfairy';

      if (
        text.includes('photo holder') ||
        text.includes('photo clip') ||
        text.includes('magnetic photo')
      ) return 'photo';

      if (
        text.includes('keychain') ||
        text.includes('keyring')
      ) return 'keychain';

      if (
        text.includes('school') ||
        text.includes('first day')
      ) return 'school';

      if (
        text.includes('dog') ||
        text.includes('pet')
      ) return 'dog';

      if (
        text.includes('cake topper') ||
        text.includes('cake')
      ) return 'cake';

      return 'product';
    }

    return 'default';
  }


  /* =====================================================
     MESSAGE ENGINE
  ===================================================== */

  function randomMessage(type) {
    const list = messages[type] || messages.default;

    let chosen = list[Math.floor(Math.random() * list.length)];

    if (list.length > 1) {
      while (chosen === lastMessage) {
        chosen = list[Math.floor(Math.random() * list.length)];
      }
    }

    lastMessage = chosen;
    return chosen;
  }

  function showBubble(text, duration = 6500) {
    clearTimeout(bubbleTimer);

    message.textContent = text;

    bubble.classList.remove('is-hidden');
    bubble.classList.add('is-visible');

    bubble.style.display = 'block';
    bubble.style.opacity = '1';
    bubble.style.visibility = 'visible';

    bubbleTimer = setTimeout(hideBubble, duration);
  }

  function hideBubble() {
    bubble.classList.remove('is-visible');
    bubble.classList.add('is-hidden');
    bubble.style.opacity = '';
    bubble.style.visibility = '';
  }


  /* =====================================================
     STORIE ANIMATIONS
  ===================================================== */

  function littlePeek() {
    if (mascot.classList.contains('is-hidden')) return;

    mascot.classList.add('is-peeking');

    setTimeout(function () {
      mascot.classList.remove('is-peeking');
    }, 1200);
  }

  function littleBounce() {
    mascot.classList.add('is-bouncing');

    setTimeout(function () {
      mascot.classList.remove('is-bouncing');
    }, 700);
  }


  /* =====================================================
     FIND SHOPIFY INBOX
  ===================================================== */

  function findChatButton(root = document) {
    const selectors = [
      '#shopify-chat-button',
      '[data-shopify-chat-button]',
      'button[aria-label*="chat" i]',
      'button[title*="chat" i]',
      '[class*="shopify-chat"] button',
      '[class*="inbox"] button'
    ];

    for (const selector of selectors) {
      try {
        const found = root.querySelector(selector);

        if (
          found &&
          found !== mascotButton &&
          !mascot.contains(found)
        ) {
          return found;
        }
      } catch (e) {}
    }

    let all = [];

    try {
      all = root.querySelectorAll('*');
    } catch (e) {}

    for (const element of all) {
      if (element.shadowRoot) {
        const found = findChatButton(element.shadowRoot);
        if (found) return found;
      }
    }

    return null;
  }


  /* =====================================================
     OPEN SHOPIFY INBOX
  ===================================================== */

  function openInbox() {
    const chatButton = findChatButton();

    if (chatButton) {
      chatButton.click();
      return true;
    }

    /* Shopify Inbox can load after the rest of the page */
    let attempts = 0;

    const waiter = setInterval(function () {
      attempts++;

      const delayedButton = findChatButton();

      if (delayedButton) {
        clearInterval(waiter);
        delayedButton.click();
      }

      if (attempts >= 10) {
        clearInterval(waiter);

        showBubble(
          'I’m here! 💛 Tap the Chat button and send me your question.',
          7000
        );
      }
    }, 300);

    return false;
  }


  /* =====================================================
     TAP STORIE
  ===================================================== */

  mascotButton.addEventListener('click', function (event) {
    event.preventDefault();

    interactionCount++;

    littleBounce();

    openInbox();
  });


  /* =====================================================
     CLOSE STORIE
  ===================================================== */

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      mascot.classList.add('is-hidden');

      sessionStorage.setItem(
        'jco_mascot_hidden',
        'true'
      );
    });
  }


  /* =====================================================
     RESTORE HER
  ===================================================== */

  if (
    sessionStorage.getItem('jco_mascot_hidden') !== 'true'
  ) {
    mascot.classList.remove('is-hidden');
  }


  /* =====================================================
     FIRST HELLO
  ===================================================== */

  setTimeout(function () {
    if (mascot.classList.contains('is-hidden')) return;

    const context = getContext();

    showBubble(
      randomMessage(context),
      7000
    );

    littlePeek();
  }, 1200);


  /* =====================================================
     MESSAGE WHEN CUSTOMER SCROLLS
  ===================================================== */

  window.addEventListener(
    'scroll',
    function () {
      if (scrollMessageShown) return;
      if (mascot.classList.contains('is-hidden')) return;

      const total =
        document.documentElement.scrollHeight -
        window.innerHeight;

      if (total <= 0) return;

      const progress =
        window.scrollY / total;

      if (progress > 0.42) {
        scrollMessageShown = true;

        setTimeout(function () {
          showBubble(
            randomMessage(getContext()),
            6000
          );
        }, 600);
      }
    },
    { passive: true }
  );


  /* =====================================================
     AFTERPAY MOMENT
  ===================================================== */

  if (
    document.body.innerText
      .toLowerCase()
      .includes('afterpay')
  ) {
    setTimeout(function () {
      if (
        !mascot.classList.contains('is-hidden') &&
        getContext() === 'product'
      ) {
        showBubble(
          randomMessage('afterpay'),
          5500
        );
      }
    }, 15000);
  }


  /* =====================================================
     OCCASIONAL PEEK
     No constant jumping around — just enough personality
  ===================================================== */

  setInterval(function () {
    if (document.hidden) return;
    if (mascot.classList.contains('is-hidden')) return;

    littlePeek();
  }, 50000);


  /* =====================================================
     RETURNING VISITOR
  ===================================================== */

  const visits =
    parseInt(
      localStorage.getItem('jco_storie_visits') || '0',
      10
    ) + 1;

  localStorage.setItem(
    'jco_storie_visits',
    visits
  );

  if (visits >= 3) {
    setTimeout(function () {
      if (!mascot.classList.contains('is-hidden')) {
        showBubble(
          'Oh hi again! ☁️ I knew you’d be back 💛',
          5500
        );
      }
    }, 9000);
  }
});